function SHOW_RESET(state) {
    return state.showReset;
};

export {
    SHOW_RESET,
};